import { extendTheme } from 'native-base';
import { Platform, StyleSheet } from 'react-native';
const fontConfig = {
  Roboto: {
    100: {
      normal: Platform.select({
        ios: 'Roboto-Light',
        android: 'Roboto-Light',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-LightItalic',
        android: 'Roboto-LightItalic',
        web: 'Roboto'
      })
    },
    200: {
      normal: Platform.select({
        ios: 'Roboto-Light',
        android: 'Roboto-Light',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-LightItalic',
        android: 'Roboto-LightItalic',
        web: 'Roboto'
      })
    },
    300: {
      normal: Platform.select({
        ios: 'Roboto-Light',
        android: 'Roboto-Light',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-LightItalic',
        android: 'Roboto-LightItalic',
        web: 'Roboto'
      })
    },
    400: {
      normal: Platform.select({
        ios: 'Roboto-Regular',
        android: 'Roboto-Regular',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-Italic',
        android: 'Roboto-Italic',
        web: 'Roboto'
      })
    },
    500: {
      normal: Platform.select({
        ios: 'Roboto-Medium',
        android: 'Roboto-Medium',
        web: 'Roboto'
      })
    },
    600: {
      normal: Platform.select({
        ios: 'Roboto-Medium',
        android: 'Roboto-Medium',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-MediumItalic',
        android: 'Roboto-MediumItalic',
        web: 'Roboto'
      })
    },
    700: {
      normal: Platform.select({
        ios: 'Roboto-Bold',
        android: 'Roboto-Bold',
        web: 'Roboto'
      })
    },
    800: {
      normal: Platform.select({
        ios: 'Roboto-Bold',
        android: 'Roboto-Bold',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-BoldItalic',
        android: 'Roboto-BoldItalic',
        web: 'Roboto'
      })
    },
    900: {
      normal: Platform.select({
        ios: 'Roboto-Bold',
        android: 'Roboto-Bold',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-BoldItalic',
        android: 'Roboto-BoldItalic',
        web: 'Roboto'
      })
    }
  }
};
const fonts = {
  heading: 'Roboto',
  body: 'Roboto',
  mono: 'Roboto'
};
const fontSizes = {
  '2xs': 10,
  'xs': 12,
  'sm': 14,
  'md': 16,
  'lg': 18,
  'xl': 20,
  '2xl': 24,
  '3xl': 28,
  '4xl': 40,
  '5xl': 48,
  '6xl': 60,
  '7xl': 72,
  '8xl': 96,
  '9xl': 128
};
const sizes = {
  12.5: 50,
  14: 56,
  18: 72,
  28: 112,
  50: 200,
  54: 216
};
const colors = {
  primary: {
    '50': '#3999ff',
    '100': '#1384fe',
    '200': '#0871e0',
    '300': '#0d5eb4',
    '400': '#0a4a8d',
    '500': '#0c3f75',
    '600': '#0d345d',
    '700': '#0d2846',
    '800': '#0b1d30',
    '900': '#08111c'
  },
  black: {
    1000: '#333333',
    900: '#302F2F',
    800: '#666666',
    700: '#656565',
    600: '#888889',
    500: '#8E8E8E',
    400: '#AFAFAF',
    300: '#979797',
    200: '#000000'
  },
  grey: {
    900: '#687583',
    800: '#8E98A2',
    700: '#B3BAC1',
    600: '#bebebe',
    500: '#D9DCE0',
    400: '#F1F1F1',
    300: '#FF0000',
    200: '#425364'
  },
  blue: {
    '50': '#3999ff',
    '100': '#1384fe',
    '200': '#0871e0',
    '300': '#0d5eb4',
    '400': '#0a4a8d',
    '500': '#0c3f75',
    '600': '#0d345d',
    '700': '#0d2846',
    '800': '#0b1d30',
    '900': '#08111c',
    '950': '#3F85D7',
    1000: '#020407'
  },
  gold: {
    '50': '#edd998',
    '100': '#e2ca7b',
    '200': '#d5ba60',
    '300': '#c5a848',
    '400': '#ae9337',
    '500': '#968038',
    '600': '#806f37',
    '700': '#6a5e34',
    '800': '#574e31',
    '900': '#443e2c'
  },
  navyblue: {
    '50': '#357ecb',
    '100': '#336aa5',
    '200': '#2f5782',
    '300': '#284360',
    '400': '#1d3146',
    '500': '#182432',
    '600': '#121920',
    '700': '#0a0d10',
    '800': '#010102',
    '900': '#EFF9FE'
  },
  darkblue: {
    '900': '#0a58ca',
    '800': '#095cd4'
  },
  green: {
    '50': '#34ffc9',
    '100': '#0cffbe',
    '200': '#00e3a7',
    '300': '#04b888',
    '400': '#03906a',
    '500': '#067658',
    '600': '#085d46',
    '700': '#094535',
    '800': '#082e24',
    '900': '#051914'
  },
  red: {
    '50': '#f5aeae',
    '100': '#ed8f8f',
    '200': '#e27272',
    '300': '#d55757',
    '400': '#cc3736',
    '500': '#b63636',
    '600': '#9e3737',
    '700': '#873737',
    '800': '#713535',
    '900': '#5d3232'
  },
  white: {
    900: '#E8E8E8',
    800: '#EEEEEE',
    700: '#FFFFFF'
  },
  border: {
    primary: '#0A4A8D',
    inverse: '#979797',
    light: '#D1D3D4',
    danger: '#D63D34'
  },
  text: {
    running: '#222A34'
  },
  circle: {
    secondary: '#E8ECF2'
  }
};
const shadows = {
  10: {
    shadowColor: 'rgba(0,0,0,0.09)',
    shadowOffset: {
      width: 5,
      height: 7
    },
    shadowOpacity: 1,
    shadowRadius: 6,
    elevation: 8
  }
};
const theme = extendTheme({
  colors,
  fontSizes,
  sizes,
  fontConfig,
  fonts,
  shadows,
  components: {
    Link: {
      baseStyle: {
        ...Platform.select({
          web: {
            cursor: 'pointer'
          }
        }),
        fontWeight: 'bold',
        color: 'primary.400',
        _hover: {
          color: 'darkblue.900'
        }
      }
    },
    Text: {
      baseStyle: {
        color: 'text.running',
        fontFamily: 'body',
        fontWeight: 'normal'
      }
    },
    Header: {
      baseStyle: {
        color: 'black.900'
      }
    },
    Button: {
      variants: {
        freedom: _ref => {
          let {
            colorScheme
          } = _ref;
          return {
            bg: `${colorScheme}.400`,
            rounded: 'md',
            width: 50,
            height: 14,
            _text: {
              color: 'white.700',
              textTransform: 'uppercase',
              fontWeight: 'medium'
            },
            _hover: {
              bg: '#052546'
            }
          };
        },
        freedomOutline: _ref2 => {
          let {
            colorScheme
          } = _ref2;
          return {
            bg: 'white.700',
            rounded: 'md',
            width: 50,
            height: 14,
            borderColor: `${colorScheme}.500`,
            borderWidth: 2,
            borderRadius: 4,
            _text: {
              color: `${colorScheme}.500`,
              textTransform: 'uppercase',
              fontWeight: 'medium',
              fontSize: 'md'
            }
          };
        }
      }
    },
    FormControlLabel: {
      baseStyle: {
        _text: {
          fontSize: 'md',
          color: 'black.200',
          fontWeight: 500,
          ml: 3,
          mb: 1
        }
      }
    },
    FormControlErrorMessage: {
      mt: 1
    },
    Input: {
      variants: {
        unstyled: {
          bg: 'white.700',
          _focus: {
            bg: 'white.700',
            borderColor: '#687583'
          },
          _hover: {
            borderColor: '#687583'
          },
          borderColor: '#687583',
          borderWidth: 2,
          _invalid: {
            borderColor: 'border.danger',
            _hover: {
              borderColor: 'border.danger'
            },
            _focus: {
              borderColor: 'border.danger'
            },
            _stack: {
              style: {
                boxShadow: `0 0 0 0px #D63D34`
              }
            }
          }
        }
      }
    }
  }
});
export const styles = StyleSheet.create({
  shadow: {
    backgroundColor: '#ffffff',
    shadowColor: '#e0e0e080',
    shadowOffset: {
      width: 6,
      height: 6
    },
    shadowOpacity: 1,
    shadowRadius: 7,
    elevation: 5
  },
  shadow2: {
    shadowColor: '#000',
    shadowOffset: {
      width: 3,
      height: 3
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 7
  },
  shadow3: {
    shadowColor: 'rgba(0,0,0,0.09)',
    shadowOffset: {
      width: 5,
      height: 7
    },
    shadowOpacity: 1,
    shadowRadius: 6,
    elevation: 8
  }
});
export default theme;
//# sourceMappingURL=index.js.map